import { loc } from "../i18n/survey";
import { locIconButton } from "./utils";

enum CardioFrequency {
  Rarely = "Rarely",
  Occasionally = "Occasionally",
  Frequently = "Frequently",
}

const cardioQuestion = {
  name: 'cardio',
  title: loc("quiz.cardio.title"),
  description: loc("quiz.cardio.description"),
  type: "radiogroup",
  choices: [
    {
      value: CardioFrequency.Rarely,
      text: locIconButton("quiz.cardio.choices.rarely", "🛋️"),
    },
    {
      value: CardioFrequency.Occasionally,
      text: locIconButton("quiz.cardio.choices.occasionally", "🚶"),
    },
    {
      value: CardioFrequency.Frequently,
      text: locIconButton("quiz.cardio.choices.frequently", "💪"),
    },
  ],
  isRequired: true,
};

export {
  CardioFrequency,
  cardioQuestion,
}